define([
	"dojo/_base/declare",
	"csi/table/AggregateFrom"
], function(declare,AggregateFrom) {

	return declare(AggregateFrom, {
		idKey: "SysID"
	});
});